Controller.$inject = [];

function Controller() {
    let self = this;

    self.getUserAvatarBg = () => {
        return Utils.stringToColor(`${this.id}-${this.firstName}-${this.lastName}`);
    }
}

export function HuiAvatar() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            sizing: '@?',
            firstName: '@?',
            lastName: '@?',
            imageUrl: '@?',
            shape: '@?',
            id: '@'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-avatar" 
                 ng-style="{'background-image': $huiCtrl.imageUrl ? 'url(' + $huiCtrl.imageUrl + ')' : '',
                 'background-color' : !$huiCtrl.imageUrl && '#' + $huiCtrl.getUserAvatarBg()
                 }"
                 ng-class="[ 
                            $huiCtrl.sizing || 'md',  
                            $huiCtrl.shape || 'circle',
                            !$huiCtrl.imageUrl ? 'hui-char-avatar' : ''   
                        ]"
                >
                <span ng-if="!$huiCtrl.imageUrl" class="hui-chars">
                    {{ $huiCtrl.firstName && $huiCtrl.firstName.charAt(0).toUpperCase() }}{{ $huiCtrl.lastName && $huiCtrl.lastName.charAt(0).toUpperCase() }}
                </span>
               </div>
            `;
        }
    }
}